/**
 * O texto original do provedor, para o admin.
 *
 * Fechado por padrão: o que o operador precisa ler é a frase acima dele. Este
 * é o que o suporte copia para investigar — por isso a fonte de código e a
 * quebra em qualquer ponto, já que o texto costuma ser um JSON sem espaço e
 * um link comprido que estourariam o cartão no celular.
 */
export function DetalheTecnico({
  detalhe,
}: {
  detalhe: { texto: string; dica: string | null } | null | undefined;
}) {
  if (!detalhe) return null;

  return (
    <details className="min-w-0 text-[0.75rem]">
      <summary className="cursor-pointer text-texto-fraco">Detalhe técnico</summary>
      {detalhe.dica && <p className="mt-1.5 leading-snug text-texto-suave">{detalhe.dica}</p>}
      <p className="mt-1.5 font-mono text-[0.6875rem] leading-snug text-texto-fraco wrap-anywhere">
        {detalhe.texto}
      </p>
    </details>
  );
}
